import styled from 'styled-components';

import { media } from '@/shared/components';
import { COLORS } from '@/shared/constants/colors';

export const Container = styled.div`
  width: 100%;
  padding: 16px;
  border-radius: 12px;
  border: 1px solid ${COLORS.systemDark100};
  display: grid;
  gap: 16px;
`;

export const Title = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 12px;
  line-height: 16px;
`;

export const BtnClose = styled.button`
  width: 24px;
  height: 24px;
  border: 0;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;

  background: ${COLORS.systemLight200};
  cursor: pointer;
`;

export const FieldsGroup = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;

  ${media.mobile} {
    grid-template-columns: 1fr;
  }
`;
